import $ from 'jquery';
import { getBreakpoints } from '../utils/utils';

const breakPoint = getBreakpoints().lg;
const timeToEffect = 250;

const $hamburger = $('#left-menu');
const $menu = $('.left-menu');
const $menuLink = $('.left-menu__link');
const $menuBlackout = $('.left-menu__blackout');
const $menuBody = $('.left-menu__body');
const $menuHeader = $('.left-menu__header');
const $body = $('body');

function animationHamburger() {
  $hamburger.find('.c-hamburger__item--1').toggleClass('open');
  $hamburger.find('.c-hamburger__item--2').toggleClass('open');
  $hamburger.find('.c-hamburger__item--3').toggleClass('open');
  $hamburger.find('.c-hamburger__item--4').toggleClass('open');
}

function submenuCloseAll(openAll = false, exclude = false) {
  return new Promise((resolve) => {
    if (openAll) {
      $menuLink.animate({ opacity: '1' }, timeToEffect, 'linear');
    } else if (exclude) {
      $menuLink.not(exclude).animate({ opacity: '0.5' }, timeToEffect, 'linear');
    } else {
      $menuLink.animate({ opacity: '0.5' }, timeToEffect, 'linear');
    }
    $('.left-menu__link.open').removeClass('open');
    $('.left-menu__submenu-outer').animate({ opacity: '0' }, timeToEffect, 'linear', function () {
      $(this).addClass('d-none').removeClass('d-flex');
      resolve();
    });
  });
}

async function submenuOpen(event) {
  await submenuCloseAll(false, event.target);
  const $closest = $(event.target).closest('.left-menu__item');
  $closest.find('.left-menu__link').addClass('open');
  $closest.find('.left-menu__submenu-outer').addClass('d-flex').removeClass('d-none').animate({ opacity: '1' }, timeToEffect, 'linear');
}

function menuOpen() {
  $body.addClass('overflow-hidden');
  $('.header').addClass('left-menu-open');
  $menuLink.removeAttr('style');
  $menu.show().trigger('open');
  $('.left-menu__hamburger').append($hamburger);
  $('.left-menu__hamburger').find('.c-hamburger').focus();
  $menuBlackout.show().animate({ opacity: '0.6' }, timeToEffect, 'linear', function () {
    $(this).show().addClass('open');
  });
  $menuBody.animate({ left: '0' }, timeToEffect, 'linear');
  $menuHeader.animate({ opacity: '1' }, timeToEffect, 'linear');
  const defaultFocusElms = $('body').find('a, button, input, video');
  const setFocusElms = $('body').find('div, span');
  defaultFocusElms.each(function () {
    if ($(this).attr('tabindex')) {
      $(this).attr('temppocket', $(this).attr('tabindex'));
      $(this).attr('tabindex', '-1');
    } else if ($(this).attr('tabindex') === undefined) {
      $(this).attr('temppocket', 'null');
      $(this).attr('tabindex', '-1');
    }
  });
  setFocusElms.each(function () {
    if ($(this).attr('tabindex') === '0') {
      $(this).attr('temppocket', $(this).attr('tabindex'));
      $(this).attr('tabindex', '-1');
    }
  });
  $('.left-menu a').attr('tabindex', '0');
  $('#left-menu').attr('tabindex', '0');
}

async function menuClose() {
  $menuBlackout.animate({ opacity: 0 }, timeToEffect, 'linear', function () {
    $(this).hide().removeClass('open');
  });
  $menuBody.animate({ left: '-500px' }, timeToEffect, 'linear', () => {
    $menu.hide();
  });
  $menuHeader.animate({ opacity: '0' }, 200, 'linear', () => {
    $('.header__hamburger--sub').append($hamburger);
    animationHamburger();
  });
  $body.removeClass('overflow-hidden');
  $('.header').removeClass('left-menu-open');
  await submenuCloseAll();
  $menuLink.removeAttr('style');
  $menu.trigger('close');
  $('button').eq(0).focus();
  const defaultFocusElms = $('body').find('a, button, input, video');
  const setFocusElms = $('body').find('div, span');
  defaultFocusElms.each(function () {
    if ($(this).attr('temppocket') === '-1' || $(this).attr('temppocket') === '0') {
      $(this).attr('tabindex', $(this).attr('temppocket'));
      $(this).removeAttr('temppocket');
    } else if ($(this).attr('temppocket') === 'null') {
      $(this).removeAttr('tabindex');
      $(this).removeAttr('temppocket');
    }
  });
  setFocusElms.each(function () {
    if ($(this).attr('temppocket')) {
      $(this).attr('tabindex', '0');
      $(this).removeAttr('temppocket');
    }
  });
  $('.left-menu a').removeAttr('tabindex');
  $('#left-menu').removeAttr('tabindex');
}

function toggleHamburger() {
  $hamburger.toggleClass('open');
  if ($hamburger.hasClass('open')) {
    animationHamburger();
    menuOpen();
  } else {
    menuClose();
  }
}

$hamburger.on('click tap', () => {
  toggleHamburger();
});

$menuLink.on('click tap', (event) => {
  if ($(event.currentTarget).attr('href') === '#') {
    event.preventDefault();
  }

  if ($(event.target).hasClass('open')) {
    submenuCloseAll(true);
  } else {
    submenuOpen(event);
  }
});

$(window).on('resize', () => {
  if ($hamburger.hasClass('open')) {
    $hamburger.removeClass('open');
    menuClose();
  }
});

export default true;
